import { useRef, useState } from 'react';
import { Helmet } from 'react-helmet';
import { useForm } from 'react-hook-form';
import {
  Button, Form, FormControl, FormLabel, Spinner, Alert, Col
} from 'react-bootstrap';

import useAuth from '../hooks/useAuth';
import StatusAlert from '../components/StatusAlert';
import { emailPattern } from '../common/constants';
import './auth.css';

function ForgotPassword() {
  const title = 'Forgot Password';

  const [isLoading, setIsLoading] = useState(false);
  const { sendPasswordReset } = useAuth();
  const {
    register, handleSubmit, formState: { errors },
  } = useForm();

  const alertOpts = useRef({ isShow: false, variant: 'success', message: '' });
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');

  const handleDismiss = () => {
    alertOpts.current.isShow = false;
  };

  const handleSend = async (data) => {
    try {
      setIsLoading(true);
      await sendPasswordReset(data);
      setMessage('Password reset email sent. Please check your inbox.');
      setError('');
      alertOpts.current = { isShow: true, variant: 'success', message: 'Password reset email sent. Please check your inbox.' };
      setIsLoading(false);
    } catch (err) {
      setError('Failed to send password reset email. Please try again.');
      setMessage('');
      alertOpts.current = { isShow: true, variant: 'failure', message: err.message };
      setIsLoading(false);
    }
  };

  return (
    <>
      <Helmet>
        <title>{title}</title>
      </Helmet>
      <div className="container-fluid mb-5 px-3">
        <div className="row mx-auto align-content-center" style={{ maxWidth: "30rem", minHeight: "70vh" }}>
          <div className="card card-lg bg-white p-4" >
            <div className="card-body">
              <Form noValidate>
                <div className="row mb-3">
                  <div className="text-center">
                    {/*  <i className="bi bi-file-lock-fill auth-icon fw-normal mt-5 text-center" /> */}
                  </div>
                  <h4 className="text-secondary">Request Password Reset</h4>
                  <p className="small my-0">Enter your email so that we can send a password reset link to you.</p>
                  <Form.Group as={Col} lg="12" controlId="inputEmail">
                    <FormLabel></FormLabel>
                    <FormControl type="email"
                      isInvalid={errors.email}
                      placeholder="Email@domain.com"
                      {
                      ...register('email', {
                        required: true,
                        pattern: emailPattern,
                      })
                      }
                    />
                    <Form.Control.Feedback type="invalid">
                      {errors.email?.type === 'required' && 'Email is required'}
                      {errors.email?.type === 'pattern' && 'Invalid email'}
                    </Form.Control.Feedback>
                  </Form.Group>
                  <Button className="w-100 btn btn-lg btn-primary mt-3"
                    type="button"
                    disabled={isLoading}
                    onClick={handleSubmit(handleSend)}
                  >
                    <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" hidden={!isLoading} />
                    <span className="px-2">Reset Password</span>
                  </Button>

                </div>
                <div className="row mb-3">
                  {message && <Alert variant="success">{message}</Alert>}
                  {error && <Alert variant="danger">{error}</Alert>}
                </div>
              </Form>

            </div>
          </div>
        </div>
      </div>
      <StatusAlert show={alertOpts.current.isShow}
        variant={alertOpts.current.variant}
        message={alertOpts.current.message}
        onDismiss={handleDismiss}
      />
    </>
  );
}

export default ForgotPassword;
